var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileNotch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 9.875C6.3125 9.875 6.5 10.0625 6.5 10.25C6.5 10.4609 6.3125 10.625 6.125 10.625H3.875C3.66406 10.625 3.5 10.4609 3.5 10.25C3.5 10.0625 3.66406 9.875 3.875 9.875H6.125ZM7.625 0.5C8.44531 0.5 9.125 1.17969 9.125 2V11C9.125 11.8438 8.44531 12.5 7.625 12.5H2.375C1.53125 12.5 0.875 11.8438 0.875 11V2C0.875 1.17969 1.53125 0.5 2.375 0.5H7.625ZM8 11V2C8 1.8125 7.8125 1.625 7.625 1.625H6.5V2.375C6.5 2.58594 6.3125 2.75 6.125 2.75H3.875C3.66406 2.75 3.5 2.58594 3.5 2.375V1.625H2.375C2.16406 1.625 2 1.8125 2 2V11C2 11.2109 2.16406 11.375 2.375 11.375H7.625C7.8125 11.375 8 11.2109 8 11Z",
    fill: "#1D2132"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNotch);
export default __webpack_public_path__ + "static/media/mobile-notch.ad6ef548b6f3af8e467fa5a0d1da7b1b.svg";
export { ForwardRef as ReactComponent };